import BoilerplateListing from "./BoilerplateListing";

export default BoilerplateListing;